<template>
  <div>
    <dashboard-page-title :showFilter="true" :showSearch="true" :showExportation="true" @addEvent="$router.push({name: 'companyAddDriver'})">{{$t('drivers.drivers')}}</dashboard-page-title>
    <main-table :fields="fields" :list_url="'drivers/company'"></main-table>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import { VUE_APP_TRANSPORTATION_LINK } from '@/config/constant'
// import productServices from '@/modules/products/services/products'
// import { VUE_APP_TRANSPORTATION_LINK } from '@/config/constant'
export default {
  components: {},
  mounted () {
    core.index()
  },
  data () {
    return {
      VUE_APP_TRANSPORTATION_LINK,
      fields: [

        { label: this.$t('drivers.driverName'), key: 'name', class: 'text-right' },
        { label: this.$t('drivers.phoneNumber'), key: 'name', class: 'text-right' },
        { label: this.$t('drivers.tripsCount'), key: 'numberOfTrips', class: 'text-right' },
        { label: this.$t('drivers.imports'), key: 'profits', class: 'text-right' },
        { label: this.$t('drivers.paymentWay'), key: 'quantity', class: 'text-right' },
        { label: this.$t('drivers.lastTrip'), key: 'latestLocation', class: 'text-right' },
        {
          label: this.$t('drivers.control'),
          key: 'actions',
          class: 'text-right',
          type: 'actions',
          actions: [
            {
              text: 'view',
              icon: 'ri-eye-fill',
              color: 'primary',
              ifNavigate: true,
              routePath: 'show-driver/:id'
            },
            {
              text: 'edit',
              icon: 'ri-ball-pen-fill',
              color: 'info',
              ifNavigate: true,
              routePath: 'edit-driver/:id'
            },
            {
              text: 'Delete',
              icon: 'ri-delete-bin-line',
              color: 'danger',
              url: 'drivers',
              baseUrl: VUE_APP_TRANSPORTATION_LINK,
              titleHeader: 'سائق',
              question: 'هل متأكد أنك تريد مسح هذا السائق',
              textContent: 'name',
              textDeleteButton: 'بالتأكيد, مسح',
              textCancelButton: 'الغاء',
              showAlert: true
            }
          ]
        }
      ]
    }
  },
  methods: {}
}
</script>
